import React, { Component } from "react";

import httpClient from '../../httpClient'
import { Button, Modal,  ModalBody , Form, FormGroup, Label, Input } from 'reactstrap';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { signUp } from "../../slices/modalSlice";
import PhoneInput from 'react-phone-input-2'
class SignupForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
         modalSignup: false,
         fields: {email: '', password: ''},
         error : false
    
        };
    
      
  }
  
      toggleSignup() {
        this.setState({
          modalLogin:false,
          modalSignup: !this.state.modalSignup
        });
      }

      onInputChange(evt) {
		this.setState({
			fields: {
				...this.state.fields,
				[evt.target.name]: evt.target.value
			}
		})
    }

	onFormSubmitSignup(evt) {
		evt.preventDefault()
		httpClient.signUp(this.state.fields).then(user => {
			if(user) {
        this.setState({ fields: { name: '', email: '', password: '' } })
				this.props.onSignUpSuccess(user);
        this.props.history.push('/home');
        this.toogleClose();		
      }
      else{
        console.log(user);
        this.setState({
          error : true
        })
      }
		})
	}
  toogleClose = () =>{
    this
    .props
    .dispatch(signUp())
}

openSignUpForm = () =>{
  this
  .props
  .dispatch({type: "SIGNUP_FORM"})
}
openSignUpProForm = () =>{
  this
  .props
  .dispatch({type: "SIGNUP_PRO_FORM"})
}
    
    
  render() {

    const { name, email, password} = this.state.fields
    const error = this.state.error
    return (
        <div>
          <Modal isOpen={this.props.signUp} toggle={this.toogleClose} className={this.props.className}>
          {/* <ModalHeader toggle={this.toggle}>Modal title</ModalHeader> */}
          <img src='imgs/logo/Group_83.svg' alt='logo' className="logo-login-modal mb-3"  />
          <ModalBody>
            <Form className="form-login"  onChange={this.onInputChange.bind(this)} onSubmit={this.onFormSubmitSignup.bind(this)}>
              <center>
                <h4 className="mb-5">Crée un Compte</h4>
                <div className="d-flex justify-content-between mb-5" style={{width:"70%",backgroundColor:""}}>
                  <button className="auth0-btn gg-bt py-2 px-2 align-items-center">
                    <i>
                      <img src="/imgs/logo/google.png" className="gg-insc-icon mr-1" alt="google" /></i>
                    via Google
                  </button>
                  <button className="auth0-btn fb-bt py-2 px-3  d-flex align-items-center">
                    <i className="fb-insc-icon mr-1">
                    <svg viewBox="0 0 512 512" className="fb-svg">
                    <path d="M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"/>
                    </svg>
                    </i>
                    via Facebook
                  </button>
                </div>
              </center>
              

              <div className="row mx-0 align-items-center legend-box">
                  {!error&&<span className="auth-box-title">Entrer vos informations</span>}
                  {error&&<span className="auth-box-title" style={{color:'red'}}>Correcter vos informations</span>}
                  <div className="row mx-0 align-items-center my-4">
                    <input type="text" minLength={4} name="name" id="UserName" className="auth-input mb-2" placeholder="Nom d'utilisateur*" value={name}/>
                    <input type="email" className="auth-input mb-2" name="email" id="examplePassword" placeholder="Adresse e-mail*" value={email} autoComplete/>
                    <PhoneInput
                      className= "phone-input mb-2"
                      inputClass ="auth"
                      country={'dz'}
                      value={this.state.phone}
                      onChange={phone => this.setState({ phone })}
                      />
                    <input type="password" minLength={8} className="auth-input" placeholder="Mot de passe*" name="password" id="examplePassword" value={password}/>
                  </div>

              </div>

              <div className="btn-auth-box mx-0 d-flex row justify-content-between mt-4">
                <button className="insc-btn px-3 pro-insc">Inscription Pro</button>
                <div className="">
                  <button className="insc-btn px-4 mr-2 cancel-insc" onClick={e=>this.toogleClose()}>Annuler</button>
                  <button className="insc-btn px-4 insc">S'inscrire</button>
                </div>
              </div>


            {/* <div className="title-center">Veuillez remplir vos informations</div>
              <FormGroup>
                <Input type="text" name="name" id="exampleEmail" placeholder="Nom d'utilisateur" className="placeholder-center auth" value={name}></Input>
              </FormGroup>

              <FormGroup>
                  <Input type="email" className="placeholder-center" name="email" id="examplePassword" placeholder="Adress e-mail" value={email}/>
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="password" id="examplePassword" placeholder="Créer un mot de passe" value={password}/>
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="password" id="examplePassword" placeholder="Confirmer votre mot de passe"/>
              </FormGroup>

              <FormGroup check className="check-box">
                <Label check>
                  <Input type="checkbox" />{' '}
                   J'accepte les conditions générales d'utilisation
                </Label>
              </FormGroup>

              <div className="connect-button">
              <Button className="submit-button" style={{backgroundColor:"#00A706",marginBottom:"17px",borderRadius:"11px"}}>S'inscrire</Button>
              </div> */}
              
            </Form>
            </ModalBody>
          </Modal>
          </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  
    signUp:state.modal.sign,

  }
}


export default withRouter(connect(mapStateToProps)(SignupForm));